import React, { useEffect, useState } from "react";
import { PostStepProps } from "../Create";
import { Button, Col, Form, Grid, Row, Space, Spin, message } from "antd";
import { generateFormRules, handleSubmitFailed, resetErrorFormItem } from "../../../../helpers/formRules";
import { getErrorMessage } from "../../../../helpers/errorHandler";
import { ArticleProperties, EArticleStatus, EPublishTypeArticle } from "../../../../types/blog.type";
import { httpRequest } from "../../../../helpers/api";
import { successModal } from "../../../../helpers/modal";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { notificationSuccess } from "../helpers/notification";
import TextEditorBlog from "./TextEditorBlog";
import { BaseResponseProps } from "../../../../types/config.type";

interface FormProps {
	body: string;
	publishType: EPublishTypeArticle;
}

const CreateDescriptionPost: React.FC<PostStepProps> = ({ articleId, post, isEdit, setPost }) => {
	const [form] = Form.useForm<FormProps>();
	const [isLoading, setIsLoading] = useState(false);

	const history = useHistory();

	const { sm } = Grid.useBreakpoint();

	useEffect(() => {
		if (post) {
			form.setFieldsValue({
				body: post.body,
				publishType: post.publishType,
			});
		}
	}, [post]);

	const _handleSubmit = async (type: string, toIndex?: string, isDisabledValidate?: boolean) => {
		if (!isDisabledValidate) {
			try {
				await form.validateFields();
			} catch (error: any) {
				console.error(error);
				handleSubmitFailed(error);
				return;
			}
		}

		setIsLoading(true);

		try {
			const values = form.getFieldsValue();
			// const isPast = moment().isAfter(moment(post?.publicationAt));

			let status: any = "";

			if (type === "draft") {
				status = EArticleStatus.OPEN;
			} else {
				if (isEdit) {
					status = post?.status;
				} else {
					status = EArticleStatus.NEED_APPROVAL;
				}
			}

			const dto = {
				body: values.body,
				status,
			};
			var postResults: ArticleProperties;

			try {
				if (articleId) {
					let { data } = await httpRequest.patch<BaseResponseProps<ArticleProperties>>(
						"/articles/" + articleId,
						dto
					);
					postResults = data.payload;
				} else {
					let { data } = await httpRequest.post<BaseResponseProps<ArticleProperties>>("/articles", {
						...dto,
					});
					postResults = data.payload;
				}
			} catch (error) {
				message.error(getErrorMessage(error));
				setIsLoading(false);
				return;
			}

			if (type === "draft") {
				successModal({
					title: "Drafted!",
					subtitle: "Blog saved as draft!",
					onOk: () => {
						history.replace(`/blog-posts?activeTab=${EArticleStatus.OPEN}`);
					},
				});

				setIsLoading(false);

				return;
			} else if (type === "submit") {
				notificationSuccess({
					message: `The post has been ${isEdit ? "Updated" : "Created"}`,
					// description: `Now, you can check your ${isEdit ? "Update" : ""} post in the list`,
					description: "Now, you wait until the post is approved by admin",
					onClose() {
						history.replace(`/blog-posts?activeTab=${postResults.status || EArticleStatus.PUBLISH}`);
					},
					duration: 1.5,
				});
			} else {
				if (isEdit) {
					history.push(`/blog-posts/${postResults.articleId}/edit/${toIndex}`);
				} else {
					history.push(`/blog-posts/create/${postResults.articleId}/${toIndex}`);
				}
			}
		} catch (error) {
			console.log(error);
			message.error(getErrorMessage(error));
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Spin spinning={isLoading}>
			<Form
				form={form}
				layout="vertical"
				autoComplete="off"
				onFinishFailed={handleSubmitFailed}
			>
				<Row gutter={[24, 0]}>
					<Col span={24}>
						<Form.Item
							name="body"
							label="Description"
							rules={generateFormRules("Description", ["required"])}
						>
							<TextEditorBlog
								articleId={articleId!}
								onChange={(content) => {
									if (!content.replace(/<(?!img\b)[^>]*>/gi, "")) {
										form.setFieldValue("body", undefined);
									} else {
										form.setFieldValue("body", content);
									}

									// form.setFieldValue("body", content);
								}}
							/>
						</Form.Item>
					</Col>

					<Form.Item
						noStyle
						name="publishType"
					/>

					<Col
						span={24}
						style={{ height: 20 }}
					></Col>

					<Col span={24}>
						{sm ? (
							<Row style={{ justifyContent: "space-between" }}>
								<Col>
									<Button
										type="primary"
										className="btn-fixed-lg"
										onClick={() => _handleSubmit("no", "detail-post", true)}
										loading={isLoading}
									>
										Previous
									</Button>
								</Col>
								<Col>
									<Space>
										<Button
											loading={isLoading}
											onClick={() => _handleSubmit("draft")}
											className="btn-secondary"
										>
											Save to Draft
										</Button>
										<Button
											type="primary"
											className="btn-fixed-lg"
											onClick={() => _handleSubmit("submit")}
											loading={isLoading}
										>
											{isEdit ? "Update" : "Create"}
										</Button>
									</Space>
								</Col>
							</Row>
						) : (
							<Row gutter={[12, 12]}>
								<Col span={12}>
									<Button
										loading={isLoading}
										onClick={() => _handleSubmit("draft")}
										className="btn-secondary"
										block
									>
										Save to Draft
									</Button>
								</Col>
								<Col span={12}>
									<Button
										type="primary"
										className="btn-fixed-lg"
										onClick={() => _handleSubmit("submit")}
										loading={isLoading}
										block
									>
										{isEdit ? "Update" : "Create"}
									</Button>
								</Col>
								<Col span={24}>
									<Button
										block
										type="primary"
										className="btn-fixed-lg"
										onClick={() => _handleSubmit("no", "detail-post", true)}
										loading={isLoading}
									>
										Previous
									</Button>
								</Col>
							</Row>
						)}
					</Col>
				</Row>
			</Form>
		</Spin>
	);
};

export default CreateDescriptionPost;
